
import uniqueId from 'lodash/uniqueId';

import {
  getEditorModalName
} from 'zoomforth_codesbane_editor/lib/modals.js';

export const showModal = (ModalComponent, modalProps)=> {
  return {
    type: 'SET_CURRENT_EDITOR_MODAL',
    name: getEditorModalName(ModalComponent),
    props: modalProps,
    ident: uniqueId()
  };
};

export const closeModal = ()=> {
  return {
    type: 'SET_CURRENT_EDITOR_MODAL',
    name: null,
    props: {}
  };
};
